module.exports = __webpack_public_path__ + "img/bih_logo@2x.ab9f8a71.png";